module.exports = __webpack_public_path__ + "img/rogers.23cd69f4.jpg";